export default {
  models_dashboardModel: null,
  addedWidgetKey: '',
}
